import { FormattedMessage } from 'react-intl';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import { rivals } from 'lib/glossary';

import { PlayingStatusIcon } from './PlayingStatusIcon';

type Props = { starting: boolean };
export const PlayingStatus = ({ starting }: Props) => {
  return (
    <Horizontal center gap={0.5}>
      <PlayingStatusIcon starting={starting} width={12} />
      <LabelS>
        {starting ? (
          <FormattedMessage {...rivals.starting} />
        ) : (
          <FormattedMessage {...rivals.notStarting} />
        )}
      </LabelS>
    </Horizontal>
  );
};
